let gptLoadPromise = null;

export function ensureGptLoaded(limitedAds = false) {
  if (typeof window !== 'undefined' && window.googletag && window.googletag.apiReady) {
    return Promise.resolve(window.googletag);
  }

  if (gptLoadPromise) {
    return gptLoadPromise;
  }

  gptLoadPromise = new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
      resolve(null);
      return;
    }

    window.googletag = window.googletag || {};
    window.googletag.cmd = window.googletag.cmd || [];

    const domain = limitedAds ? 'pagead2.googlesyndication.com' : 'securepubads.g.doubleclick.net';
    const scriptTag = document.createElement('script');
    scriptTag.src = `${document.location.protocol}//${domain}/tag/js/gpt.js`;
    scriptTag.async = true;
    scriptTag.type = 'text/javascript';

    scriptTag.onerror = err => {
      gptLoadPromise = null;
      reject(err);
    };

    scriptTag.onload = () => {
      resolve(window.googletag);
    };

    document.head.appendChild(scriptTag);
  });

  return gptLoadPromise;
}
